import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
// @ts-ignore
import { bindActionCreators, Dispatch } from "redux";
import {
  addStudents,
  assignStudentsToTeacher,
  clearStoredCsvFile,
  getEvidenceInDataPeriod,
  getTeachers,
  hidePickDataSourceModal,
  hideUploadStudentDataModal,
  openSearchForYourAssessmentModal,
  updateCsvFileRawData,
  uploadAssessmentData,
  uploadCsvFile,
  uploadMultipleCsvFile,
  uploadEvidenceData,
  openUploadStudentDataModal,
  openFileUploadErrorModal,
} from "../../../../../store/onboarding/actions";
import { connect } from "react-redux";
import {
  Assessment,
  BenchmarkStatus,
  BenchmarkStatusDefaultColors,
  BenchmarkStatusDisplayedNames,
  ColorCriteria,
  DataPeriod,
  EvidenceData,
  EvidencePeriodData,
  Measurement,
  MeasurementType,
  PossibleValue,
  Student,
} from "../../../../../store/onboarding/types";
import UploadInfo from "./UploadInfo";
import Table from "react-bootstrap/Table";
import UploadingDataGuide from "./UploadingDataGuide";
import ColumnHeadersSelectorPanel from "./ColumnHeadersSelectorPanel";
import DataMetricColumnsPreview from "./DataMetricColumnsPreview";
import { ApplicationState } from "../../../../../store";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronLeft, faPlusCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import Papa from "papaparse";
import EditMeasureColorCriteriaModal from "../../../color-picker/EditMeasureColorCriteriaModal";
import { Button, Form, Spinner, Tab, Tabs } from "react-bootstrap";
import { uploadedAssessment, UserAssignmentRole, UserInfo } from "../../../../../store/auth/types";
import { toastr } from "react-redux-toastr";
import SearchForYourAssessmentModal from "./SearchForYourAssessmentModal";
import EditPossibleValuesModal from "../evidence-tab/EditPossibleValuesModal";
import PreviewDataCell from "./PreviewDataCell";
import FileRecognizedContent from "./FileRecognizedContent";
import FileUnrecognizedContent from "./FileUnrecognizedContent";
import MeasurementsTable from "./MeasurementsTable";
import { addStudentMapToLocalStore } from "../../../../../utils/StudentMapUtils";
import { Grade, SkillFocusArea, TimePeriod } from "../../../../../store/groups/types";
import { GoalTypes } from "../../../../../store/onboarding/cases/types";
import { getSkillFocuses } from "../../../../../store/groups/actions";
import _ from "lodash";
import { resetFilterAction, resetPagination, resetSortAction } from "../../../../../store/dataFilter/actions";
import { showConfirmDialog } from "../../../../../store/confirm-dialog/actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FileType } from "../../../file-reader/FileReaderHelpers";


library.add(faTimesCircle, faPlusCircle);

type PropsFromState = {
  showModal: boolean;
  originalFileName: string;
  columnsNames: Array<string>;
  currentDataPeriod?: DataPeriod;
  rawData: Array<any>;
  uploadCSVArray: any;
  isLoading: {
    uploadAssessmentData: boolean;
    assignStudentsToTeacher: Array<number>;
    uploadEvidenceData: boolean;
    addStudents: boolean;
    detectAssessment: boolean;
  };
  assessments: Array<Assessment>;
  evidencePeriodData?: EvidencePeriodData;
  selectedAssessment?: Assessment;
  teachers: Array<UserInfo>;
  errors: {
    uploadAssessmentData?: string | Array<any>;
    assignStudentsToTeacher: Array<{ teacherId: number; message: string }>;
    uploadEvidenceData?: string | Array<any>;
    addStudents?: string | Array<any>;
    detectAssessment?: string;
  };

  uploadedAssessment: uploadedAssessment;
  dataPeriods: Array<DataPeriod>;
  currentRole: UserAssignmentRole;
  currentAssignmentRole: UserAssignmentRole;
  myId: number;
  enterDataManuallyType?: GoalTypes;
  areas: SkillFocusArea[];
};

type DispatchProps = {
  uploadCsvFile: (
    fileName: string,
    columnsNames: Array<string>,
    rawData: Array<any>
  ) => any;
  uploadMultipleCsvFile: (uploadCSVArray:any) => any
  getEvidenceInDataPeriod: (dataPeriodId?: number) => any;
  clearStoredCsvFile: () => any;
  uploadEvidenceData: (evidence: EvidenceData, isDistrictAdmin: boolean) => any;
  assignStudentsToTeacher: (id: number, students: Array<Student>) => any;
  addStudents: (students: Array<Student>) => any;
  getTeachers: () => any;
  uploadAssessmentData: (
    assessmentId: number,
    rawCsvData: any,
    csvFileName: string,
    target_evidence_column_group_id?: number,
    dataPeriodId?: number,
    source?: string,
    grade?: Grade,
    timePeriod?: TimePeriod,
    year?: string,
    sheetRawData?: any,
    isDistrictOwner?: boolean,
    upload_in_existing_shared_dp?: boolean,
    shared_data_period_selected?: number[],
    new_students_only?: string,
    currentDataPeriodIds?: number[]
  ) => any;
  updateRawDataOfCsvFile: (rawData: any) => any;
  openSearchForYourAssessmentModal: () => any;
  onHide: () => void;
  hidePickDataSourceModal: () => any;
  getSkillFocuses: () => any;
  resetPagination: () => any;
  resetFilterAction: () => any;
  resetSortAction: () => any;
  showConfirmDialog: (confirmObj: any) => any;
  openUploadStudentDataModal: () => void;
  openFileUploadErrorModal: (message: any) => void;
};

type OwnProps = {
  storybookInitialState?: State;
  isDistrictOwner?: boolean;
};

type State = {
  selectedMeasurement?: Measurement;
  numPreviewRows: number;
  basicColumnsHeadersNum: Readonly<number>;
  showEditMeasureColorCriteriaModal: boolean;
  showEditPossibleValuesModal: boolean;
  fileAccepted: boolean;
  assessmentName: string;
  selectedStudentIdColumn: string;
  selectedStudentFirstNameColumn: string;
  selectedStudentLastNameColumn: string;
  selectedStudentTeacherColumn: string;
  selectedStudentGradeColumn: string;
  selectedStudentRaceColumn: string;
  selectedStudentGenderColumn: string;
  selectedStudentELLColumn: string;
  selectedStudentSLDColumn: string;
  selectedStudentSpecialEducationColumn: string;
  selectedStudentFreeOrReducedLunchColumn: string;
  selectedColumnNames: Array<string>;
  measurements: Array<Measurement>;
  selectedRows: Array<SelectedRow>;
  loadingTeacherIds: Array<number>;
  isMergeData: boolean;
  showConfirmation: boolean;
  useGradeSpecificColor: boolean;
  withReadingAlgorithm: boolean;
  supportedGrades: Grade[];
  timePeriods: TimePeriod[];
  benchmarkStatuses: BenchmarkStatus[];
  raBenchmarkForNumericType: ColorCriteria[];
  raBenchmarkForCategoryType: Pick<
    Measurement,
    "possible_values" | "color_criteria" | "type"
  >;
  newMeasurement: Measurement,
  // selectedSearchFilter: any;
  searchFilter: any;
  skill_areas: any;
  editMeasureIndex: number;
  multiRawDataCount: number;
  multiSheetCount: number;
};

type SelectedRow = {
  isSelected: boolean;
  willBeImported: boolean;
  student: Student;
  teacher?: UserInfo;
};

type Props = PropsFromState & DispatchProps & OwnProps;
class UploadStudentDataModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedRows: [],
      fileAccepted: false,
      // selectedAssessment: undefined,
      showEditMeasureColorCriteriaModal: false,
      showEditPossibleValuesModal: false,
      assessmentName: "",
      selectedStudentIdColumn: "",
      selectedStudentFirstNameColumn: "",
      selectedStudentLastNameColumn: "",
      selectedStudentTeacherColumn: "",
      selectedStudentGradeColumn: "",
      selectedStudentRaceColumn: "",
      selectedStudentGenderColumn: "",
      selectedStudentELLColumn: "",
      selectedStudentSLDColumn: "",
      selectedStudentSpecialEducationColumn: "",
      selectedStudentFreeOrReducedLunchColumn: "",
      selectedColumnNames: [],
      numPreviewRows: 3,
      basicColumnsHeadersNum: 3,
      measurements: [],
      loadingTeacherIds: [],
      isMergeData: false,
      showConfirmation: false,
      useGradeSpecificColor: false,
      withReadingAlgorithm: false,
      supportedGrades: ["K", "G1", "G2", "G3", "G4", "G5", "G6", "G7", "G8", "G9", "G10", "G11", "G12"],
      timePeriods: Object.values(TimePeriod),
      benchmarkStatuses: Object.values(BenchmarkStatus),
      raBenchmarkForNumericType: [],
      raBenchmarkForCategoryType: {
        possible_values: [],
        color_criteria: []
      },
      newMeasurement: {
        display_name: "",
        column_index: 0,
        column_name: "",
        type: MeasurementType.NUMBER,
        reading_skill: undefined,
        color_criteria: undefined,
        unique_id: 0,
        isAddNew: true,
      },
      skill_areas: [],
      editMeasureIndex: 0,
      searchFilter: {},
      multiRawDataCount: 0,
      multiSheetCount: 0
    };

    if (props.storybookInitialState) {
      this.state = Object.assign(this.state, props.storybookInitialState);
    }
  }

  getInitialSearchObj = () => {
    const gradeOrder = ["K", ...Array.from({ length: 12 }, (_, i) => `G${i + 1}`)];
    return {
      filterIndex: 0,
      filterGrade: [],
      filterAdditionalBenchmark: true,
      ...gradeOrder.reduce((acc, grade) => {
        acc[`selectFor${grade}`] = [];
        return acc;
      }, {} as any),
    };
  };

  initialSetState = () => {
    this.props.getSkillFocuses();

    this.setState({
      skill_areas : this.state.useGradeSpecificColor
                      ? this.props.areas?.map((sf) => ({
                          label: sf.display_name,
                          value: sf.identifier,
                        })) ?? []
                      : []
    });

    const colorCriteriaList: ColorCriteria[] = [];
    this.state.supportedGrades.forEach((grade) => {
      this.state.timePeriods.forEach((timePeriod) => {
        let orderKey = 1;
        this.state.benchmarkStatuses.forEach((benchmarkStatus) => {
          const colorCriteria: ColorCriteria = {
            display_name: BenchmarkStatusDisplayedNames[benchmarkStatus],
            color: BenchmarkStatusDefaultColors[benchmarkStatus],
            grade: grade,
            time_period: timePeriod,
            benchmark_status: benchmarkStatus,
            order: orderKey++
          };
          colorCriteriaList.push(colorCriteria);
        });
      });
    });

    this.setState({ raBenchmarkForNumericType: colorCriteriaList}) ;

    this.setState({
      newMeasurement: {
          display_name: "",
          column_index: 0,
          column_name: "",
          type: MeasurementType.NUMBER,
          reading_skill: undefined,
          color_criteria: this.state.useGradeSpecificColor
            ? colorCriteriaList
            : undefined,
          unique_id: Date.now(),
          isAddNew: true,
      }
    })

    this.setState((prevState: State) => ({
      ...prevState,
      searchFilter: this.getInitialSearchObj(),
    }));

    this.setState((prevState: State) => ({
      ...prevState,
      measurements: []
    }), () =>
      this.setState((prevState: State) => ({
        ...prevState,
        measurements: [
          ...prevState.measurements,
          this.state.newMeasurement
        ],
      }))
    );


  this.setState(prevState => ({
    ...prevState,
    possible_values: this.state.benchmarkStatuses.map((benchmarkStatus, index) => ({
      display_name: BenchmarkStatusDisplayedNames[benchmarkStatus],
      order: index + 1,
    })),
    color_criteria: this.state.benchmarkStatuses.map((benchmarkStatus, index) => ({
      order: index + 1,
      selected_value_order: index + 1,
      display_name: BenchmarkStatusDisplayedNames[benchmarkStatus],
      color: BenchmarkStatusDefaultColors[benchmarkStatus],
    })),
  }));
  }

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    snapshot?: any
  ): void {
    if (
      prevProps.isLoading.uploadEvidenceData &&
      !this.props.isLoading.uploadEvidenceData
    ) {
      if (!this.props.errors.uploadEvidenceData) {
        this.props.hidePickDataSourceModal();
        if (this.props.currentRole !== UserAssignmentRole.DISTRICT_OWNER) {
          this.props.resetFilterAction();
          this.props.resetSortAction();
          this.props.resetPagination();
          this.props.getEvidenceInDataPeriod();
        }
        const { rawData } = this.props;

        const studentMap = new Map<string, Student>(
          rawData.map((row) => [
            row[this.state.selectedStudentIdColumn],
            {
              first_name: row[this.state.selectedStudentFirstNameColumn],
              last_name: row[this.state.selectedStudentLastNameColumn],
            },
          ])
        );
        addStudentMapToLocalStore(studentMap);
      } else {
        if (JSON.stringify(this.props.errors.uploadEvidenceData)?.includes('tab_name')) {
          this.props.openFileUploadErrorModal(this.props.errors.uploadEvidenceData)
        } else {
          const errorMsg = Array.isArray(this.props.errors.uploadEvidenceData)
            ? this.props.errors.uploadEvidenceData.join(", ")
            : this.props.errors.uploadEvidenceData;
          toastr.error("Failed", errorMsg || "An error occurred");
        }
      }
    }

    if (
      prevProps.isLoading.uploadAssessmentData &&
      !this.props.isLoading.uploadAssessmentData
    ) {
      if (this.props.errors.uploadAssessmentData) {
        //toastr.error("Error", this.props.errors.uploadAssessmentData);
      } else {
        const { rawData, assessments } = this.props;
        if (assessments[0]) {
          const studentMap = new Map<string, Student>(
            rawData.map((row) => [
              row[assessments[0].unique_id_column],
              {
                // The below is a hack to work with Acadience
                first_name:
                  row[assessments[0].first_name_column] || row["first_name"],
                last_name:
                  row[assessments[0].last_name_column] || row["last_name"],
              },
            ])
          );
          addStudentMapToLocalStore(studentMap);
        }
        this.props.hidePickDataSourceModal();
        // RC-1557 stop the call 
        // if(this.props.currentAssignmentRole
        //   !== UserAssignmentRole.DISTRICT_OWNER) { // RC-1247 stop the calls
        //     this.props.getEvidenceInDataPeriod();
        //   }
      }
    }

    if (
      prevProps.isLoading.detectAssessment &&
      !this.props.isLoading.detectAssessment
    ) {
      if (this.props.errors.detectAssessment) {
        toastr.error("Failed", this.props.errors.detectAssessment);
      } else {
        let multiRawDataCount = 0;
        let multiSheetCount = 0;
        let uploadCSVArray = this.props.uploadCSVArray;
        for (const key in uploadCSVArray) {
          if(!Object.prototype.isPrototypeOf.call(uploadCSVArray, key)) {
            multiSheetCount++;
            if(uploadCSVArray[key]?.rawData?.length) {
              multiRawDataCount += uploadCSVArray[key]?.rawData?.length;
            }
          }
        }  
        this.setState({
          multiRawDataCount,
          multiSheetCount
        }) 
    
      }
    }

    // Reset multiRawDataCount and multiSheetCount when a new file is uploaded
    if (prevProps.originalFileName !== this.props.originalFileName) {
      this.setState({
        multiRawDataCount: 0,
        multiSheetCount: 0
      });
    }

    if (!prevState.fileAccepted && this.state.fileAccepted) {
      this.checkColumnNamesForAutoselection();
      this.initialSetState();
    }

    // Re-run column autoselection when a new file is uploaded while modal is already open
    if (
      this.state.fileAccepted &&
      prevProps.originalFileName !== this.props.originalFileName &&
      this.props.originalFileName
    ) {
      // Reset selected columns first
      this.setState({
        selectedColumnNames: [],
        selectedStudentIdColumn: "",
        selectedStudentFirstNameColumn: "",
        selectedStudentLastNameColumn: "",
        selectedStudentTeacherColumn: "",
        selectedStudentGradeColumn: "",
        selectedStudentRaceColumn: "",
        selectedStudentGenderColumn: "",
        selectedStudentELLColumn: "",
        selectedStudentSLDColumn: "",
        selectedStudentSpecialEducationColumn: "",
        selectedStudentFreeOrReducedLunchColumn: "",
      }, () => {
        // Then re-run autoselection
        this.checkColumnNamesForAutoselection();
      });
    }

    if(!prevState.withReadingAlgorithm && this.state.withReadingAlgorithm
      && this.state.skill_areas.length === 0
    ) {
       this.setState({
        skill_areas : 
          this.state.useGradeSpecificColor
            ? this.props.areas?.map((sf) => ({
                label: sf.display_name,
                value: sf.identifier,
              })) ?? []
            : []
      });
    }

    //MODAL OVERLAY CLASS HACKS

    // if (!prevProps.showModal && this.props.showModal) {
    //   document.body.style.overflow = "hidden";
    //   document.body.classList.add("modal-open");
    // }
    // if (prevProps.showModal && !this.props.showModal) {
    //   document.body.style.overflow = "";
    //   document.body.classList.remove("modal-open");
    // }
  }

  

checkColumnNamesForAutoselection = () => {
    const { columnsNames } = this.props;

    // Student ID
    // Matches:
    // Student ID, Student_ID, Student-ID, StudentId,
    // Student Primary ID, Primary ID, ID, StudentID#
    const commonStudentIdRegex =
      /^(?:student[\s_-]*)?(?:primary[\s_-]*)?id#?$/i;
    const commonStudentIdColumn = columnsNames.find((columnName) =>
      commonStudentIdRegex.test(columnName.trim())
    );

    // First Name
    // Matches:
    // First Name, FirstName, First,
    // Student First Name, StudentFirstName,
    // Student (by itself)
    const commonStudentFirstNameRegex =
      /^(?:(?:student[\s_-]*)?first(?:[\s_-]*name)?|student)$/i;
    const commonStudentFirstNameColumn = columnsNames.find((columnName) =>
      commonStudentFirstNameRegex.test(columnName.trim())
    );

    // Last Name
    // Matches:
    // Last Name, LastName, Last,
    // Student Last Name, StudentLastName
    const commonStudentLastNameRegex =
      /^(?:student[\s_-]*)?last(?:[\s_-]*name)?$/i;
    const commonStudentLastNameColumn = columnsNames.find((columnName) =>
      commonStudentLastNameRegex.test(columnName.trim())
    );

    // Teacher
    // Matches:
    // Teacher
    // Teacher Name
    // Teacher_Name
    // Official Teacher
    // Official Teacher Name
    // RaterName
    // Rater Name
    // Rater_Name
    // Teacher_K
    // Teacher_1st ... Teacher_12th
    const commonTeacherRegex =
      /^(?:(?:official[\s_-]*)?teacher|rater)(?:[\s_-]*(?:name|K|(?:[1-9](?:st|nd|rd|th)|1[0-2]th)))?$/i;

    const commonTeacherColumn = columnsNames.find((columnName) =>
      commonTeacherRegex.test(columnName.trim())
    );

    // Grade
    // Matches:
    // Grade, Student Grade, Enrollment Grade,
    // GradeAtRating, Grade Rating
    const commonGradeRegex =
      /^(?:(?:student|enrollment)[\s_-]*)?grade(?:[\s_-]*at)?(?:[\s_-]*rating)?$/i;
    const commonGradeColumn = columnsNames.find((columnName) =>
      commonGradeRegex.test(columnName.trim())
    );

    // Race
    // Matches:
    // Race, Student Race
    const commonRaceRegex =
      /^(?:student[\s_-]*)?race$/i;
    const commonRaceColumn = columnsNames.find((columnName) =>
      commonRaceRegex.test(columnName.trim())
    );

    // Gender
    // Matches:
    // Gender, Student Gender, StudentGender
    const commonGenderRegex =
      /^(?:student[\s_-]*)?gender$/i;
    const commonGenderColumn = columnsNames.find((columnName) =>
      commonGenderRegex.test(columnName.trim())
    );

    // ELL
    // Matches all variations from DemographicAdditionalContent:
    // ELL, Student ELL, ELL Status, Student ELL Status
    // EngLangLearn (DESSA)
    // ELL? (Y or N) (MClass, LinkIt)
    const commonELLRegex =
      /^(?:(?:student[\s_-]*)?ell(?:[\s_-]*status)?(?:\?[\s_-]*\(y[\s_-]*or[\s_-]*n\))?|englanglearn)$/i;
    const commonELLColumn = columnsNames.find((columnName) =>
      commonELLRegex.test(columnName.trim())
    );

    // SLD
    // Matches all variations from DemographicAdditionalContent:
    // SLD, Student SLD, SLD Status, Student SLD Status
    // Specific Disability
    // Specific Learning Disability? (Y or N) (MClass, LinkIt)
    const commonSLDRegex =
      /^(?:(?:student[\s_-]*)?sld(?:[\s_-]*status)?|specific[\s_-]*(?:learning[\s_-]*)?disability(?:\?[\s_-]*\(y[\s_-]*or[\s_-]*n\))?)$/i;
    const commonSLDColumn = columnsNames.find((columnName) =>
      commonSLDRegex.test(columnName.trim())
    );

    // Special Education
    // Matches all variations from DemographicAdditionalContent:
    // Special Education, Student Special Education
    // SpecialEdSvc (DESSA)
    const commonSpecialEducationRegex =
      /^(?:student[\s_-]*)?special(?:[\s_-]*(?:education|edsvc))$/i;
    const commonSpecialEducationColumn = columnsNames.find((columnName) =>
      commonSpecialEducationRegex.test(columnName.trim())
    );

    // Free or Reduced Lunch
    // Matches all variations from DemographicAdditionalContent:
    // Free or Reduced Lunch, Free Reduced Lunch, Free & Reduced Lunch
    // Free/Reduced Lunch, Free/Reduced Lunch? (Y or N) (MClass, LinkIt)
    // Meal Status (MClass)
    // Student Meal Status
    // FreeReduced (DESSA)
    const commonFreeOrReducedLunchRegex =
      /^(?:(?:student[\s_-]*)?(?:meal[\s_-]*status|freereduced|free[\s_-]*(?:\/|or|&)?[\s_-]*reduced[\s_-]*lunch(?:\?[\s_-]*\(y[\s_-]*or[\s_-]*n\))?))$/i;
    const commonFreeOrReducedLunchColumn = columnsNames.find((columnName) =>
      commonFreeOrReducedLunchRegex.test(columnName.trim())
    );

    const selectedColumnNames: string[] = [
      commonStudentIdColumn,
      commonStudentFirstNameColumn,
      commonStudentLastNameColumn,
      commonTeacherColumn,
      commonGradeColumn,
      commonRaceColumn,
      commonGenderColumn,
      commonELLColumn,
      commonSLDColumn,
      commonSpecialEducationColumn,
      commonFreeOrReducedLunchColumn,
    ].filter(Boolean) as string[];

    this.setState((state) => ({
      ...state,
      selectedColumnNames: [
        ...state.selectedColumnNames,
        ...selectedColumnNames,
      ],
      selectedStudentIdColumn:
        commonStudentIdColumn ?? state.selectedStudentIdColumn,
      selectedStudentFirstNameColumn:
        commonStudentFirstNameColumn ??
        state.selectedStudentFirstNameColumn,
      selectedStudentLastNameColumn:
        commonStudentLastNameColumn ??
        state.selectedStudentLastNameColumn,
      selectedStudentTeacherColumn:
        commonTeacherColumn ?? state.selectedStudentTeacherColumn,
      selectedStudentGradeColumn:
        commonGradeColumn ?? state.selectedStudentGradeColumn,
      selectedStudentRaceColumn:
        commonRaceColumn ?? state.selectedStudentRaceColumn,
      selectedStudentGenderColumn:
        commonGenderColumn ?? state.selectedStudentGenderColumn,
      selectedStudentELLColumn:
        commonELLColumn ?? state.selectedStudentELLColumn,
      selectedStudentSLDColumn:
        commonSLDColumn ?? state.selectedStudentSLDColumn,
      selectedStudentSpecialEducationColumn:
        commonSpecialEducationColumn ??
        state.selectedStudentSpecialEducationColumn,
      selectedStudentFreeOrReducedLunchColumn:
        commonFreeOrReducedLunchColumn ??
        state.selectedStudentFreeOrReducedLunchColumn,
    }));
  };

  handleAcceptFile = () => {
    if (this.props.originalFileName) this.setState({ fileAccepted: true });
  };

  handleBackToFileReview = () => {
    this.setState({
      fileAccepted: false,
      selectedColumnNames: [],
      selectedStudentIdColumn: "",
      selectedStudentFirstNameColumn: "",
      selectedStudentLastNameColumn: "",
      selectedStudentTeacherColumn: "",
      selectedStudentGradeColumn: "",
      selectedStudentRaceColumn: "",
      selectedStudentGenderColumn: "",
      selectedStudentELLColumn: "",
      selectedStudentSLDColumn: "",
      selectedStudentSpecialEducationColumn: "",
      selectedStudentFreeOrReducedLunchColumn: "",
      measurements: [],
    });
  }

  handleChange = (event: React.FormEvent) => {
    const { name, value } = event.target as HTMLInputElement;
    this.setState((prevState: State) => {
      const selectedColumnNames =
        name !== "assessmentName"
          ? [
              ...prevState.selectedColumnNames.filter(
                (columnName: string) => (prevState as any)[name] !== columnName
              ),
              value,
            ]
          : prevState.selectedColumnNames;
      return {
        ...prevState,
        [name]: value,
        selectedColumnNames: selectedColumnNames,
      };
    });
  };

   handleMeasurementAdd = () => {
    const newMeasurement = {
      ...this.state.newMeasurement,
      unique_id: Date.now(),
      isAddNew: true,
    };
    this.setState((prevState: State) => ({
      ...prevState,
      measurements: [
        ...prevState.measurements,
        newMeasurement,
      ]
    }));
  };

  handleMeasurementsChange = (id: number, columnNamesSelector?: boolean, unique_id?: number) => (
    event: React.SyntheticEvent
  ) => {
    const { name, value } = event.target as HTMLInputElement;
    this.setState((prevState: State) => {
      if (["type", "range_min", "range_max"].includes(name)) {
        return {
          ...prevState,
          searchFilter: {
            ...prevState.searchFilter,
            [String(unique_id)]: {
              ...this.getInitialSearchObj(),
              filterIndex: unique_id, // optional but usually correct
            },
          },
        };
      }
      return prevState;
    });
    this.setState((prevState: State) => {
      const measurements = prevState.measurements.map(
        (measurement: Measurement, index: number) => {
          if (index === id) {
            if (name === "type") {
              const defTypeValues = this.getDefaultTypeValues(
                +value,
                measurement
              );
              return {
                ...measurement,
                ...defTypeValues,
                [name]: +value,
              };
            }
            if (name === "column_name") {
              return {
                ...measurement,
                [name]: value,
                display_name: value,
              };
            }
            return {
              ...measurement,
              [name]: value,
            };
          }
          return measurement;
        }
      );
      return {
        ...prevState,
        measurements: measurements,
        selectedColumnNames: columnNamesSelector
          ? [
              ...prevState.selectedColumnNames.filter(
                (columnName) =>
                  columnName !== prevState.measurements[id].column_name
              ),
              value,
            ]
          : prevState.selectedColumnNames,
      };
    });
  };

  handleSkillAreasChange = (index:number, skill: string) => {
    const updatedMeasurement:any = [...this.state.measurements.map((m, mIndex) =>
      index === mIndex
        ? { ...m, reading_skill: skill }
        : m
    )]
    this.setState({measurements: updatedMeasurement})
  }

  handlePossibleValuesChange = (measurement: Measurement) => (index: number) => {
    
    this.setState({
      selectedMeasurement: {...measurement, column_index: index},
      showEditPossibleValuesModal: true,
    });
  };

  getDefaultTypeValues(measureType: MeasurementType, measurement: Measurement) {
    let defaultValues: Partial<Measurement>;
    switch (measureType) {
      case MeasurementType.NUMBER:
        defaultValues = {
          range_min: 200,
          range_max: 800,
          possible_values: undefined,
          color_criteria: undefined,
        };
        break;
      case MeasurementType.PERCENTAGE:
        defaultValues = {
          range_min: 0,
          range_max: 100,
          possible_values: undefined,
          color_criteria: undefined,
        };
        break;
      case MeasurementType.CATEGORY: {
        const uniqueValues = this.props.rawData
          .map((rawRow) => rawRow[measurement.column_name!])
          .filter((item, index, arr) => arr.indexOf(item) >= index);
        const possible_values: Array<PossibleValue> = uniqueValues.map(
          (value: string, index: number) => ({
            order: index + 1, //on backend start at 1
            display_name: value,
          })
        );
        defaultValues = {
          range_min: undefined,
          range_max: undefined,
          color_criteria: undefined,
          possible_values: possible_values,
        };
        break;
      }
      default:
        defaultValues = {};
        break;
    }
    return defaultValues;
  }

  handleMeasureEdit = (measurement: Measurement) => () => {
    if(this.state.useGradeSpecificColor) {
      let searchFilterObj: any = this.state.searchFilter[measurement.unique_id!];
      
      let mergedTimePeriod = [
          ...["K", ...Array.from({ length: 12 }, (_, i) => `G${i + 1}`)]
          .flatMap((grade) => searchFilterObj[`selectFor${grade}`] || [])
        ];
      measurement = {
        ...measurement,
        color_criteria: measurement.color_criteria
          ?.map((colorCriteria: ColorCriteria) => {
            if(mergedTimePeriod.length && searchFilterObj.filterGrade.length) {
            let isVisibleCheck = mergedTimePeriod.some(
                  (timePeriod: any) =>
                    timePeriod.grade == colorCriteria.grade
                  && timePeriod.value == colorCriteria.time_period
                );
              return ({
                ...colorCriteria,
                range_min:  isVisibleCheck ? colorCriteria.range_min : undefined,
                range_max:  isVisibleCheck ? colorCriteria.range_max : undefined,
                isVisible: isVisibleCheck
              });
            } else {
              return {
                ...colorCriteria,
                range_min: undefined,
                range_max: undefined,
                isVisible: true
              };
            }
          })
      }
      this.setState((prev: State) => {
        if ((prev.searchFilter[measurement.unique_id!] !== undefined) && mergedTimePeriod.length && searchFilterObj.filterGrade.length) {
          return prev;
        }
        return {
          ...prev,
          searchFilter: {
            ...prev.searchFilter,
            [measurement.unique_id!]: {
              ...this.getInitialSearchObj(),
              filterIndex: measurement.unique_id!, // optional but usually correct
            },
          },
        };
      });
      if(measurement.color_criteria?.length) { // when check/uncheck the userSpecified color criteria
        if(measurement.color_criteria.filter(c => c.isVisible).every((c) => (c.range_min == undefined && c.range_max == undefined))) {
          measurement = {
            ...measurement,
            isAddNew: true,
          }

          this.setState((prev: State) => {
            return {
              ...prev,
              searchFilter: {
                ...prev.searchFilter,
                [measurement.unique_id!]: {
                  ...this.getInitialSearchObj(),
                  filterIndex: measurement.unique_id!, 
                },
              },
            };
          });
        }
      }
    } else {
      measurement = {
        ...measurement,
        color_criteria: measurement.color_criteria
          ?.map((colorCriteria: ColorCriteria) => {
            return {
              ...colorCriteria,
              isVisible: true
            };
          })
      };
      if(!measurement.color_criteria?.length) { // when check/uncheck the withoutReadingAlgorithm color criteria
        measurement = {
          ...measurement,
          isAddNew: true,
        }
      }
    }
    this.setState({
      editMeasureIndex: measurement.unique_id!,
      selectedMeasurement: measurement,
      showEditMeasureColorCriteriaModal: true,
    });
  };

  handleMeasurementRemove = (measurement: Measurement) => () => {
    const confirmAndRemove = () => {
      this.setState((prevFilter:any) => {
          const newFilter = {...prevFilter};
          delete newFilter[measurement.unique_id!];
          return newFilter;
        });
        this.setState((prevState: State) => {
          const foundMeasurement = prevState.measurements?.find((m) => m?.unique_id == measurement.unique_id);
          const columnName = foundMeasurement ? foundMeasurement.column_name : undefined;

          const selectedColumnNames = prevState.selectedColumnNames.filter(
            (val) => val != columnName
          );

          const measurements = prevState.measurements.filter(
            (m: Measurement, index: number) => !(m.unique_id === measurement.unique_id)
          );
          return {
            ...prevState,
            selectedColumnNames,
            measurements: measurements,
          };
        });
    }
     if(measurement.color_criteria
      ?.some((c) =>
        c.range_min != undefined
        && c.range_max != undefined
      )) {
      this.props.showConfirmDialog({
        title: "Remove Data Column",
        text: (
          <>
            <p className="text-center font-weight-bold">Are you sure you want to remove this data column?</p>
            <p className="text-center">This action cannot be undone.</p>
          </>
        ),
        onConfirm: () => confirmAndRemove(),
        confirmButtonText: "REMOVE",
      });
      } else {
        confirmAndRemove();
      } 
  };

  handleEditMeasureColorCriteriaModalHide = () => {
    this.setState({ showEditMeasureColorCriteriaModal: false });
  };

  handleEditPossibleValuesModalHide = () => {
    this.setState({ showEditPossibleValuesModal: false });
  };

  handleColorCriteriaChangesApply = (updatedMeasurement: Measurement, searchFilter: any) => {
    if (this.state.useGradeSpecificColor) {
      // Merge selected time periods from searchFilter
      const mergedTimePeriod = [
        ...["K", ...Array.from({ length: 12 }, (_, i) => `G${i + 1}`)]
          .flatMap((grade) => searchFilter[`selectFor${grade}`] || [])
      ];

      this.setState((prevState: State) => {
        const measurements = prevState.measurements.map(
          (measurement: Measurement): Measurement => {
            if (measurement.unique_id === updatedMeasurement.unique_id) {
              return {
                ...measurement,
                isAddNew: false,
                color_criteria: updatedMeasurement.color_criteria?.map((colorCriteria: ColorCriteria) => {
                  const isVisibleCheck = mergedTimePeriod.some(
                    (timePeriod: any) =>
                      timePeriod.grade === colorCriteria.grade &&
                      timePeriod.value === colorCriteria.time_period &&
                      colorCriteria.range_min !== undefined &&
                      colorCriteria.range_max !== undefined &&
                      colorCriteria.isVisible
                  );
                  return {
                    ...colorCriteria,
                    range_min: isVisibleCheck ? colorCriteria.range_min : undefined,
                    range_max: isVisibleCheck ? colorCriteria.range_max : undefined,
                    isVisible: isVisibleCheck
                  };
                })
              };
            }
            return measurement;
          }
        );
        // Update searchFilter for this measurement if not already set
        const editMeasureColorIndex = updatedMeasurement.unique_id!;
        const updatedSearchFilter = prevState.searchFilter[editMeasureColorIndex] !== undefined
          ? prevState.searchFilter
          : {
              ...prevState.searchFilter,
              [editMeasureColorIndex]: {
                ...searchFilter,
                filterIndex: editMeasureColorIndex,
              },
            };
        return {
          showEditMeasureColorCriteriaModal: false,
          selectedMeasurement: undefined,
          measurements,
          searchFilter: updatedSearchFilter,
        };
      });
    } else {
      this.setState((prevState: State) => ({
        showEditMeasureColorCriteriaModal: false,
        selectedMeasurement: undefined,
        measurements: prevState.measurements.map(
          (measurement: Measurement): Measurement => {
            if (measurement.unique_id === updatedMeasurement.unique_id) {
              return {
                ...measurement,
                isAddNew: false,
                color_criteria: updatedMeasurement.color_criteria?.map((colorCriteria: ColorCriteria) => ({
                  ...colorCriteria,
                  range_min: colorCriteria.range_min,
                  range_max: colorCriteria.range_max,
                  isVisible: colorCriteria.isVisible
                }))
              };
            }
            return measurement;
          }
        ),
      }));
    }
  };

  handlePossibleValuesChangesApply = (updatedMeasurement: Measurement) => (
    event: React.FormEvent
  ) => {
    event.preventDefault();
    this.setState((prevState: State) => ({
      showEditPossibleValuesModal: false,
      selectedMeasurement: undefined,
      measurements: prevState.measurements.map(
        (measurement: Measurement): Measurement => {
          if (measurement.column_name === updatedMeasurement!.column_name) {
            return updatedMeasurement;
          }
          return measurement;
        }
      ),
    }));
  };

  handleDisplayAllRows = () => {
    this.setState({
      numPreviewRows: this.props.rawData.length,
    });
  };

  ensureDataHasUniqueIDs = (data: any, studentIdColumn: string): any => {
    const timeStamp = new Date().getTime();
    return data.map((row: any, index: number) => {
      let studentId: string | undefined;
      if (row[studentIdColumn]) {
        studentId = (row[studentIdColumn].toString() || "").trim();
        // Hack for Acadience
      } else if (row["student_id"]) {
        studentId = (row["student_id"].toString() || "").trim();
      } else if (row["StudentId"]) {
        // Hack for dessa_main. Becuase originally The studentIdColumn is Student ID 
        // but some files may have StudentId
        studentId = (row["StudentId"].toString() || "").trim();
      }  else if (row["Student ID#"]) {
        // Hack for dessa_main. Becuase originally The studentIdColumn is Student ID 
        // but some files may have StudentId
        studentId = row["Student ID#"];
        studentIdColumn = "Student ID#";
      }

      // if (studentId === undefined || (studentId && studentId.length === 0)) {
      //   studentId = `${timeStamp}_auto_${index}`;
      // }

      const copy = row;
      copy[studentIdColumn] = studentId;

      return copy;
    });
  };

  handleUploadCustomData = (event: React.FormEvent<any>) => {
    event.preventDefault();

    const first_name_column = this.state.selectedStudentFirstNameColumn;
    const last_name_column = this.state.selectedStudentLastNameColumn;
    const student_id_column = this.state.selectedStudentIdColumn;
    const {
      selectedStudentTeacherColumn,
      selectedStudentGradeColumn,
      selectedStudentRaceColumn,
      selectedStudentGenderColumn,
      selectedStudentELLColumn,
      selectedStudentSLDColumn,
      selectedStudentSpecialEducationColumn,
      selectedStudentFreeOrReducedLunchColumn
    } = this.state;

    let data = this.props.rawData;

    data = this.ensureDataHasUniqueIDs(data, student_id_column);
    this.props.updateRawDataOfCsvFile(data);

    event.preventDefault();
    if (this.state.withReadingAlgorithm && this.state.measurements.length) {
      const readingSkills = this.state.measurements.map(m => m.reading_skill);
      const hasEmpty = readingSkills.some(skill => !skill);
      const hasDuplicates = new Set(readingSkills.filter(Boolean)).size !== readingSkills.filter(Boolean).length;
      if (hasEmpty) {
      toastr.error("Alert", "Measurement(s) must have a Reading Area.");
      return;
      }
      if (hasDuplicates) {
        toastr.error("Alert", "Measurement(s) must have a unique Reading Area.");
        return;
      }
    }
    const measurementArray = [...this.state.measurements.map((measurement)=> {
      return {
        ...measurement,
        color_criteria: measurement.color_criteria
        ?.filter((data:any)=> (data.range_max !== undefined) || (data.range_min !== undefined)
        ) || [],
      }
    })];
    

    let isScoreRangeExist: boolean = true;
    for (let i = 0; i < measurementArray.length; i++) {
      const measurement = measurementArray[i];
      if(!measurement.color_criteria?.length){
        isScoreRangeExist = false;
        break;
      }
    }
    //dataColumnFormEl.current?.reportValidity();
    if (isScoreRangeExist) {
      const evidence: EvidenceData = {
        raw_csv: Papa.unparse(data),
        csv_file_name: this.props.originalFileName,
        data_period_id: this.props.currentDataPeriod!.id,
        first_name_column: first_name_column,
        last_name_column: last_name_column,
        unique_id_column: student_id_column,
        teacher_column: selectedStudentTeacherColumn,
        grade_column: selectedStudentGradeColumn,
        race_column: selectedStudentRaceColumn,
        gender_column: selectedStudentGenderColumn,
        ell_column: selectedStudentELLColumn,
        sld_column: selectedStudentSLDColumn,
        special_education_column: selectedStudentSpecialEducationColumn,
        free_or_reduced_lunch_column: selectedStudentFreeOrReducedLunchColumn,
        assessment: {
          with_reading_algorithm: this.state.withReadingAlgorithm,
          use_grade_specific_color_criteria: this.state.useGradeSpecificColor,
         // is_behavior: this.props.enterDataManuallyType == "academic" ? false : true,
          name: this.state.assessmentName,
          data_columns: this.state.useGradeSpecificColor
            ? this.state.measurements.map((m) => ({
                ...m,
                color_criteria: [],
                grade_specific_color_criteria: _.chain(m.color_criteria || [])
                  .filter((data:any)=> (data.range_max !== undefined) || (data.range_min !== undefined))
                  .groupBy((cc) => cc.grade)
                  .mapValues((cList) =>
                    _.chain(cList)
                      .groupBy((cc) => cc.time_period)
                      .value()
                  )
                  .value(),
                reading_skill: this.state.withReadingAlgorithm ? m.reading_skill : undefined
              }))
            : this.state.measurements.map((m) => {
                if(!this.state.useGradeSpecificColor && !this.state.withReadingAlgorithm) {
                  delete m.reading_skill
                }
                return m;
              }),
        },
      };
      this.props.uploadEvidenceData(evidence, this.props.currentRole === UserAssignmentRole.DISTRICT_OWNER)
      .then((response: any) => {
        if (response) {
          if(this.props.currentRole == UserAssignmentRole.DISTRICT_OWNER) {
            toastr.info('File Received', response);
            this.handleModalHide();
          } else {
            toastr.success('Success', response)
          }
        }
      });
    } else {
      toastr.error("Unable to upload evidence data", "Color criteria(s) missing for one of the Data Column(s)");   
      return; 
    }
  };

  getSheetRawData = () => {
    let sheetRawData:any[] = [];
    let uploadCSVArray = this.props.uploadCSVArray;
    let isAtLeastOneSheetExist = false;
    //let missingYearsSheets:string[] = [];
    for (const key in uploadCSVArray) {
      if(!Object.prototype.isPrototypeOf.call(uploadCSVArray, key)) {
        isAtLeastOneSheetExist = true;
        if(uploadCSVArray[key]?.rawData?.length) {
          // if(!uploadCSVArray[key].year) {
          //   missingYearsSheets.push(key);
          // }
          let time_period:string = '';
          if(key == 'Fall Data Entry') {
            time_period = 'boy';
          } else if(key == 'Winter Data Entry') {
            time_period = 'moy';
          } else if(key == 'Spring Data Entry') {
            time_period = 'eoy';
          }
          // Clean up the data
          uploadCSVArray[key].rawData.forEach((row: any) => {
            for (let prop in row) {
              // Delete any empty fields
              if (prop === "") {
                delete row[prop];
              }
            }
          });
          const element = {
            raw_csv: Papa.unparse(uploadCSVArray[key].rawData),
            grade: uploadCSVArray[key].grade,
            time_period: time_period,
            year: uploadCSVArray[key].year
          }
          sheetRawData.push(element);
        }
      }
    } 
    return {sheetRawData, isAtLeastOneSheetExist};
  }

  handleSaveStudentData = (
    assessment: Assessment,
    grade?: Grade,
    timePeriod?: TimePeriod,
    year?: string,
    upload_in_existing_shared_dp?: boolean,
    shared_data_period_selected?: number[],
    new_students_only?: string
  ) => {
    let target_evidence_column_group_id;
    if (this.props.evidencePeriodData) {
      const ecg = this.props.evidencePeriodData.evidence_column_groups.find(
        (ecg) => ecg.assessment && ecg.assessment.id === assessment.id
      );
      target_evidence_column_group_id = ecg ? ecg.id : undefined;
    }

    let data = this.props.rawData;
    // Problem with Dessa having two kinds of student id 
    const unique_id = assessment.source == 'dessa_main'
    data = this.ensureDataHasUniqueIDs(data, assessment.unique_id_column);

    this.props.updateRawDataOfCsvFile(data);

    const {sheetRawData, isAtLeastOneSheetExist} = this.getSheetRawData()
    // if(missingYearsSheets.length > 0) {
    //     let missingSheetsMsg = '';
    //     if (missingYearsSheets.length === 1) {
    //       missingSheetsMsg = missingYearsSheets[0];
    //     } else if (missingYearsSheets.length === 2) {
    //       missingSheetsMsg = `${missingYearsSheets[0]} and ${missingYearsSheets[1]}`;
    //     } else if (missingYearsSheets.length > 2) {
    //       missingSheetsMsg = `${missingYearsSheets.slice(0, -1).join(', ')}, and ${missingYearsSheets[missingYearsSheets.length - 1]}`;
    //     }
    //     toastr.error(
    //       "Failed",
    //       "",
    //       {
    //         component: (
    //           <>
    //             The school year is missing from the following sheet(s):{" "}
    //             <strong>{missingSheetsMsg}</strong>.
    //           </>
    //         )
    //       }
    //     );
    //   return;
    // }

    if(isAtLeastOneSheetExist && !sheetRawData.length) {
      toastr.error("Alert","Data not found in njtss file");
      return;
    }


    this.props.uploadAssessmentData(
      assessment.id,
      data,
      this.props.originalFileName,
      target_evidence_column_group_id,
      this.props.currentDataPeriod
        ? this.props.currentDataPeriod.id
        : (this.props.currentRole == 'district_owner') && this.props.dataPeriods.length 
            ? this.props.dataPeriods[0]['id'] :undefined,
      assessment.source,
      grade,
      timePeriod,
      year,
      sheetRawData,
      this.props.isDistrictOwner || false,
      upload_in_existing_shared_dp,
      shared_data_period_selected,
      new_students_only,
      this.props.dataPeriods.map((dp) => dp?.id)
    ).then((result:any)=> {
      this.setState({showConfirmation: true});
      if(result) {
        if(this.props.currentRole == UserAssignmentRole.DISTRICT_OWNER) {
          toastr.info('File Received', result)
        } else {
          toastr.success('Success', result)
        }
      }
    },
    (err: string) => {
      toastr.error("Failed", err);
    }
    );
  };

  // handleSelectedValueChange = (unique_id: string) => (
  //   value: ValueType<UserInfo, false>
  // ) => {
  //   this.setState((prevState) => ({
  //     selectedRows: prevState.selectedRows.map((selectedRow) => {
  //       if (unique_id === selectedRow.student.unique_id) {
  //         return {
  //           ...selectedRow,
  //           teacher: value as UserInfo,
  //         };
  //       }
  //       return selectedRow;
  //     }),
  //   }));
  // };

  handleSelectedChange = (unique_id: string) => (
    event: React.ChangeEvent<any>
  ) => {
    const { checked } = event.target;
    this.setState((prevState) => ({
      selectedRows: prevState.selectedRows.map((selectedRow) => {
        if (unique_id === selectedRow.student.unique_id) {
          return {
            ...selectedRow,
            isSelected: checked,
          };
        }
        return selectedRow;
      }),
    }));
  };

  handleAllSelectedChange = (event: React.ChangeEvent<any>) => {
    const { checked } = event.target;
    this.setState((prevState) => ({
      selectedRows: prevState.selectedRows.map((selectedRow) => ({
        ...selectedRow,
        isSelected: checked,
      })),
    }));
  };

  checkLoading = (props: Props) => {
    return props.isLoading.assignStudentsToTeacher.some((x) =>
      this.state.loadingTeacherIds.includes(x)
    );
  };

  handleNotImportRow = (selectedRow: SelectedRow) => () => {
    this.setState((prevState) => ({
      ...prevState,
      selectedRows: prevState.selectedRows.map((row) => {
        if (row.student.unique_id === selectedRow.student.unique_id) {
          return {
            ...row,
            isSelected: false,
            willBeImported: false,
          };
        }
        return row;
      }),
    }));
  };

  handleAssignSelectedStudentToTeacher = (teacher: UserInfo) => () => {
    const notSelected: boolean = this.state.selectedRows.some(
      (row) => row.isSelected
    );
    this.setState((prevState) => ({
      ...prevState,
      selectedRows: prevState.selectedRows.map((row) => {
        if (!notSelected || row.isSelected) {
          return { ...row, teacher: teacher };
        }
        return row;
      }),
    }));
  };

  handleModalShow = () => {
    if (!this.state.isMergeData) {

      //add condition
      this.setState({
        searchFilter: this.getInitialSearchObj(),
        selectedRows: [],
        fileAccepted: false,
        showEditMeasureColorCriteriaModal: false,
        assessmentName: "",
        selectedStudentIdColumn: "",
        selectedStudentFirstNameColumn: "",
        selectedStudentLastNameColumn: "",
        selectedColumnNames: [],
        numPreviewRows: 3,
        measurements: [],

        showEditPossibleValuesModal: false,
        selectedMeasurement: undefined,
        //useGradeSpecificColor: this.props.enterDataManuallyType == 'academic' ? true : false,
        useGradeSpecificColor: true,
        withReadingAlgorithm: false,
        multiRawDataCount: 0,
        multiSheetCount: 0
      });
      //(this.props.enterDataManuallyType == 'academic') && this.refreshColorCriteria(true);
      this.refreshColorCriteria(true);
      this.props.clearStoredCsvFile();
    }
  };

   refreshColorCriteria = (checked: boolean) => {
    this.setState({
      measurements: 
        [...this.state.measurements.map((m) => ({
          ...m,
          ...(m.type === MeasurementType.CATEGORY
            ? this.state.raBenchmarkForCategoryType
            : { color_criteria: checked ? this.state.raBenchmarkForNumericType : [] }),
        }
    ))]
    })
  };

  handleModalHide = () => {
    this.setState({ measurements: []}, 
      () => this.props.onHide());
  };

  handleAlertModalHide = () => {
   this.setState({showConfirmation: false})
  }

  // handleSearchFilter = (selectedSearchFilter:any) => {
  //   if(this.state.searchFilter.some((search:any)=> search.filterIndex === selectedSearchFilter.filterIndex)) {
  //     let copyObj = {...selectedSearchFilter};
  //     this.setState(searchFilter => ({
  //       ...searchFilter,
  //       [copyObj.filterIndex]: copyObj
  //     }), () =>  this.setState(selectedSearchFilter => ({
  //       ...selectedSearchFilter,
  //       [copyObj.filterIndex]: copyObj
  //     })));
  //     //this.props.setSearchFilterState(this.state.searchFilter)
  //   } 
  // }

  unfulfilledMeasurement = (measurement: Measurement): boolean => {
    if (!measurement.display_name || !measurement.column_name) return true;
    if (this.state.withReadingAlgorithm) {
      return !measurement.reading_skill;
    }
    return (
      measurement.range_min === undefined ||
      measurement.range_max === undefined
    );
  };
  isRequiedBasicInfoFilled = () => {
    const { measurements } = this.state;
    return measurements.length > 0
      && measurements.every((m) => !this.unfulfilledMeasurement(m))
      && (measurements.every((measurement) => measurement.color_criteria?.length))
      && (measurements.every((measurement) =>
          measurement.color_criteria
            ?.some((c) => c.range_min != undefined && c.range_max != undefined)))
  };

  isRequiedColorCriteriaFilled = () => {
    const { measurements } = this.state;
    return measurements.length > 0
      && (measurements.every((measurement) => measurement.color_criteria?.length))
      && (measurements.every((measurement) =>
          measurement.color_criteria
            ?.some((c) => c.range_min != undefined && c.range_max != undefined)))
  };  
  render() {
    const { originalFileName, columnsNames, rawData, myId, currentRole } = this.props;
    if(rawData.length > 10000) {
      toastr.error('Alert!!', 'Number of rows in the file should not be more than 10000')
    }
    const {
      selectedStudentIdColumn,
      selectedStudentFirstNameColumn,
      measurements,
      selectedMeasurement,
      selectedStudentLastNameColumn,
      selectedStudentTeacherColumn,
      selectedStudentGradeColumn,
      selectedStudentRaceColumn,
      selectedStudentGenderColumn,
      selectedStudentELLColumn,
      selectedStudentSLDColumn,
      selectedStudentSpecialEducationColumn,
      selectedStudentFreeOrReducedLunchColumn,
      selectedColumnNames,
      assessmentName,
      showConfirmation,
      useGradeSpecificColor,
      withReadingAlgorithm,
      fileAccepted,
      basicColumnsHeadersNum,
      skill_areas,
      showEditMeasureColorCriteriaModal,
      //selectedSearchFilter,
      showEditPossibleValuesModal,
      newMeasurement
    } = this.state;
    const basicColumnsHeadersSelected = 
      selectedStudentIdColumn &&
      selectedStudentFirstNameColumn &&
      selectedStudentLastNameColumn;
    const selectedMeasurements = measurements.filter(
      (m) => m.column_name && m.column_name !== ""
    );

    const { sheetRawData } = this.getSheetRawData();

    return (
      <>
        { !!this.props.uploadedAssessment.data_period_id && !this.props.isLoading.uploadAssessmentData
        && !this.props.errors.uploadAssessmentData 
        && showConfirmation && 
          <Modal
            id={"updated-data-period-model"}
            animation={false}
            backdropClassName="customDarkModalBackdrop inner in"
            show={showConfirmation}
            onHide={() => this.handleAlertModalHide()}
            centered
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton className="modalHeader">
              <Modal.Title className="modalTitle">
              File Uploaded
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-center"> Your file has been uploaded to the following data period(s):</p>
                {(this.props.uploadedAssessment.all_data_periods != undefined)
                 ? 
                 <>
                    <ul>
                    {this.props.uploadedAssessment.all_data_periods.map((data)=>
                      <li>
                        {data.name}  
                        {
                        [ UserAssignmentRole.COACH,
                          UserAssignmentRole.TEACHER
                        ].includes(currentRole) && myId !== data.user_id
                        ? ` (Shared by ${
                            data.user_name ? data.user_name : data.user_email
                          })`
                        : ""
                        }
                      </li>
                    )}
                    </ul>
                 </>
                  :
                 <ul>
                  {this.props.dataPeriods.filter((data)=> data.id == this.props.uploadedAssessment.data_period_id)
                  .map((dataPeriod)=> <li className="col-12">{dataPeriod.name}</li>)}
                 </ul>
                 
                }
              <hr />
              <div className="btnActions d-flex justify-content-center">
                <button onClick={() => this.handleAlertModalHide()} className="blueBtnSm">Ok</button>
              </div>
            </Modal.Body>
          </Modal>
        }
        {
          <Modal
            id={"upload-student-data-modal"}
            animation={false}
            backdropClassName="customDarkModalBackdrop in"
            show={this.props.showModal}
            size="xl"
            onShow={this.handleModalShow}
            onHide={fileAccepted ? this.handleBackToFileReview : this.handleModalHide }
            backdrop="static"
            keyboard={false}
            centered
          >
            <Modal.Header closeButton className="modalHeader">
              <Modal.Title className="modalTitle">
                Upload Student Data From A File
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {originalFileName && (
                <>
                  <UploadInfo
                    originalFileName={originalFileName}
                    rawData={rawData}
                    multiRawDataCount={this.state.multiRawDataCount}
                    isDetectAssessmentLoading={this.props.isLoading.detectAssessment}
                  />
                </>
              )}
              {fileAccepted && (
                <h4 className="mt-3 font-weight-bold">
                  Set up your assessment details and map the required student fields. You can upload a different file if needed.
                </h4>
              )}
              {originalFileName && fileAccepted && (<hr />)}
              {!fileAccepted ? (
                !originalFileName ? (
                  <UploadingDataGuide />
                ) : (
                  <>
                   
                    {this.props.isLoading.detectAssessment ? (
                      <div className="d-flex justify-content-center">
                        <Spinner animation="border" />
                      </div>
                    ) : (sheetRawData.some((sheet) => !sheet.grade || !sheet.year) && this.props.assessments) || !this.props.assessments ? (
                      //RC-2637 in case grade and year blank in NJTSS file, unrecongnized screen will be open, even if assessment detected.
                      <FileUnrecognizedContent
                        openSearchForYourAssessmentModal={
                          this.props.openSearchForYourAssessmentModal
                        }
                        //openUploadStudentDataModal={this.props.openUploadStudentDataModal}
                        handleAcceptFile={this.handleAcceptFile}
                        onHide={this.handleModalHide}
                        columnsNames={columnsNames}
                        uploadCSVArray={this.props.uploadCSVArray}
                      />
                    ) : ( 
                      <>
                        <br />
                        <FileRecognizedContent
                          handleSaveStudentData={this.handleSaveStudentData}
                          handleAcceptFile={this.handleAcceptFile}
                          assessments={this.props.assessments}
                          uploadAssessmentData={
                            this.props.isLoading.uploadAssessmentData
                          }
                          rawData={rawData}
                          multiRawDataCount={this.state.multiRawDataCount}
                          multiSheetCount={this.state.multiSheetCount}
                        />
                      </>
                    )}
                  </>
                )
              ) : (
                <>
                  <Form
                    id="uploadStudentDataForm"
                    onSubmit={this.handleUploadCustomData}
                  >
                    <ColumnHeadersSelectorPanel
                      assessmentName={assessmentName}
                      onChange={this.handleChange}
                      studentIdColumnHeader={selectedStudentIdColumn}
                      selectedColumnNames={selectedColumnNames}
                      columnNames={columnsNames}
                      studentFNameColumnHeader={selectedStudentFirstNameColumn}
                      studentLNameColumnHeader={selectedStudentLastNameColumn}
                      studentTeacherColumnHeader={selectedStudentTeacherColumn}
                      studentGradeColumnHeader={selectedStudentGradeColumn}
                      studentRaceColumnHeader={selectedStudentRaceColumn}
                      studentGenderColumnHeader={selectedStudentGenderColumn}
                      studentELLColumnHeader={selectedStudentELLColumn}
                      studentSLDColumnHeader={selectedStudentSLDColumn}
                      studentSpecialEducationColumnHeader={selectedStudentSpecialEducationColumn}
                      studentFreeOrReducedLunchColumnHeader={selectedStudentFreeOrReducedLunchColumn}
                    />
                    <div className="border border-secondary p-4 mb-4">
                      <Form.Check
                        id="use_grade_specific_color"
                        className="mb-1 font-weight-bold"
                        checked={useGradeSpecificColor}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          const hasColorCriteria = this.state.measurements.some(
                            (m) => Array.isArray(m.color_criteria) 
                            && m.color_criteria.length > 0
                            && m.color_criteria.some((cc) => cc.range_min !== undefined && cc.range_max !== undefined)
                          );
                          if (hasColorCriteria) {
                            this.props.showConfirmDialog({
                              title: "Update Selection",
                              text: "Changing the selection will reset the applied color criteria.",
                              onConfirm: () => {
                                this.refreshColorCriteria(checked);
                                this.setState({ useGradeSpecificColor: checked });
                                if (!checked) {
                                  this.setState({
                                    newMeasurement: {
                                      ...this.state.newMeasurement,
                                      color_criteria: checked
                                        ? this.state.raBenchmarkForNumericType
                                        : undefined,
                                    },
                                    withReadingAlgorithm: false,
                                  });
                                }
                              },
                              confirmButtonText: "Proceed",
                            });
                          } else {
                            this.refreshColorCriteria(checked);
                            this.setState({ useGradeSpecificColor: checked });
                            if (!checked) {
                              this.setState({
                                newMeasurement: {
                                  ...this.state.newMeasurement,
                                  color_criteria: checked
                                    ? this.state.raBenchmarkForNumericType
                                    : undefined,
                                },
                                withReadingAlgorithm: false,
                              });
                            }
                          }
                        }}
                        label="Use Grade and Time Period Specific Color Criteria"
                        custom
                        type="checkbox"
                      />
                      <p className="pl-4 assessmentCopyText">
                        When enabled, color criteria applied separately for each grade and time period.
                      </p>
                      {this.state.useGradeSpecificColor == false && (
                        <div className="pl-4 mt-2"><span className="alert alert-warning p-1" role="alert">
                          <strong>Note:</strong> Benchmarks will apply to all grades and time periods.
                        </span></div>
                      )}
                      {useGradeSpecificColor ?
                        <>
                          <hr/>
                          <Form.Check
                            id="with_reading_algorithm"
                            className="mb-1 font-weight-bold"
                            checked={withReadingAlgorithm}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              this.setState({withReadingAlgorithm: checked});
                              if(!checked) {
                                this.setState((measurements) =>({
                                  ...measurements,
                                  measurements: this.state.measurements.map((measure) => {
                                    return {
                                      ...measure,
                                      reading_skill: ""
                                    }
                                  })
                                  })
                                );
                              }
                            }}
                            label={`Use with ${this.props.enterDataManuallyType == 'behavior' ? 'Behavior' : 'Reading'} Algorithm`}
                            custom
                            type="checkbox"
                          />
                          <p className="pl-4 assessmentCopyText">
                            When enabled, this assessment will use the ReadyCoach {this.props.enterDataManuallyType == 'behavior' ? 'behavior' : 'reading'} algorithms.
                            {this.props.enterDataManuallyType == 'academic' ? 'You`ll be asked to map your assessment’s data columns to reading skills in the table below.' : ''}
                          </p>
                        </>
                      : ''
                      }
                    </div>
                    <h6 className="font-weight-bold"> Data columns</h6>
                    <hr className="m-1" />
                    {/* <DataMetricColumnsPreview
                      showTips={measurements.length === 0}
                      basicColumnsHeadersSelected={basicColumnsHeadersSelected}
                      onClick={this.handleMeasurementAdd}
                    /> */}
                    {measurements.length > 0 && (
                      <MeasurementsTable
                        basicColumnsHeadersNum={
                          basicColumnsHeadersNum
                        }
                        columnsNames={columnsNames}
                        handleMeasureEdit={this.handleMeasureEdit}
                        handleMeasurementAdd={this.handleMeasurementAdd}
                        handleMeasurementRemove={this.handleMeasurementRemove}
                        handleMeasurementsChange={this.handleMeasurementsChange}
                        handlePossibleValuesChange={
                          this.handlePossibleValuesChange
                        }
                        measurements={measurements}
                        selectedColumnNames={selectedColumnNames}
                        useGradeSpecificColor={useGradeSpecificColor}
                        withReadingAlgorithm={withReadingAlgorithm}
                        skill_areas={skill_areas}
                        handleSkillAreaChange={this.handleSkillAreasChange}
                        newMeasurement={newMeasurement}
                        isRequiedBasicInfoFilled={this.isRequiedBasicInfoFilled?.()}
                        enterDataManuallyType={this.props.enterDataManuallyType}
                      />
                    )}
                  </Form>

                  {basicColumnsHeadersSelected && (
                    <>
                      <h6 className="font-weight-bold"> Data preview</h6>
                      <div className="table-responsive react-bootstrap-table">
                        <Table className="goalTable  sticky-table-header" style={{minWidth: "max-content"}}>
                          <thead>
                            <tr>
                              <th>Student ID</th>
                              <th className="col-divider">Student First Name</th>
                              <th className="col-divider">Student Last Name</th>
                              {selectedStudentTeacherColumn && <th className="col-divider">Teacher</th>}
                              {selectedStudentGradeColumn && <th className="col-divider">Grade</th>}
                              {selectedStudentRaceColumn && <th className="col-divider">Race</th>}
                              {selectedStudentGenderColumn && <th className="col-divider">Gender</th>}
                              {selectedStudentELLColumn && <th className="col-divider">ELL</th>}
                              {selectedStudentSLDColumn && <th className="col-divider">SLD</th>}
                              {selectedStudentSpecialEducationColumn && <th className="col-divider">Special Education</th>}
                              {selectedStudentFreeOrReducedLunchColumn && <th className="col-divider">Free/Reduced Lunch</th>}
                              {selectedMeasurements.map((measurement, index) => (
                                    <th
                                      key={index}
                                      className="col-divider"
                                    >
                                      {measurement.display_name}
                                    </th>
                                  )
                                )}
                            </tr>
                          </thead>
                          <tbody>
                            {rawData
                              .slice(0, this.state.numPreviewRows)
                              .map((element: any) => (
                                <tr key={element[selectedStudentIdColumn]}>
                                  <td className="col-divider">{element[selectedStudentIdColumn]}</td>
                                  <td className="col-divider">{element[selectedStudentFirstNameColumn]}</td>
                                  <td className="col-divider">{element[selectedStudentLastNameColumn]}</td>
                                  {selectedStudentTeacherColumn && <td className="col-divider">{element[selectedStudentTeacherColumn]}</td>}
                                  {selectedStudentGradeColumn && <td className="col-divider">{element[selectedStudentGradeColumn]}</td>}
                                  {selectedStudentRaceColumn && <td className="col-divider">{element[selectedStudentRaceColumn]}</td>}
                                  {selectedStudentGenderColumn && <td className="col-divider">{element[selectedStudentGenderColumn]}</td>}
                                  {selectedStudentELLColumn && <td className="col-divider">{element[selectedStudentELLColumn]}</td>}
                                  {selectedStudentSLDColumn && <td className="col-divider">{element[selectedStudentSLDColumn]}</td>}
                                  {selectedStudentSpecialEducationColumn && <td className="col-divider">{element[selectedStudentSpecialEducationColumn]}</td>}
                                  {selectedStudentFreeOrReducedLunchColumn && <td className="col-divider">{element[selectedStudentFreeOrReducedLunchColumn]}</td>}
                                  {selectedMeasurements.map((measurement: Measurement, index: number) => (
                                        <PreviewDataCell
                                          key={measurement.id}
                                          index={index}
                                          element={element}
                                          measurement={measurement}
                                        />
                                      )
                                    )}
                                </tr>
                              ))}
                          </tbody>
                        </Table>
                      </div>
                      {rawData.length > this.state.numPreviewRows && (
                        <h6
                          className="font-weight-bold blueLink"
                          onClick={this.handleDisplayAllRows}
                          style={{ display: "inline" }}
                        >
                          And {rawData.length - this.state.numPreviewRows}{" "}
                          more...
                        </h6>
                      )}
                    </>
                  )}

                  {showEditMeasureColorCriteriaModal && 
                    <EditMeasureColorCriteriaModal
                      withGrades
                      useGradeSpecificColor={useGradeSpecificColor}
                      withReadingAlgorithm = {withReadingAlgorithm}
                      onApplyChanges={this.handleColorCriteriaChangesApply}
                      onHide={this.handleEditMeasureColorCriteriaModalHide}
                      measurement={selectedMeasurement}
                      showModal={showEditMeasureColorCriteriaModal}
                      searchFilter={this.state.searchFilter[this.state.editMeasureIndex]}
                      onHandleSearchFilter={(updatedSearchFilter: any) => 
                        this.setState((prev: State) => ({
                           ...prev, 
                           searchFilter: {
                            ...prev.searchFilter,
                            [this.state.editMeasureIndex]: updatedSearchFilter,
                          },
                        })
                      )}
                    />
                  
                  // <EditMeasureColorCriteriaModal
                  //   withGrades={useGradeSpecificColor}
                  //   useGradeSpecificColor={useGradeSpecificColor}
                  //   withReadingAlgorithm = {withReadingAlgorithm}
                  //   onApplyChanges={this.handleColorCriteriaChangesApply}
                  //   onHide={this.handleEditMeasureColorCriteriaModalHide}
                  //   measurement={selectedMeasurement}
                  //   showModal={showEditMeasureColorCriteriaModal}
                  //   // searchFilter={selectedSearchFilter}
                  //   // onHandleSearchFilter={() => this.handleSearchFilter}
                  //   editMeasureColorIndex={this.state.editMeasureIndex}
                  // />
                  }
               

                  <EditPossibleValuesModal
                    showModal={showEditPossibleValuesModal}
                    measurement={selectedMeasurement}
                    onApplyChanges={this.handlePossibleValuesChangesApply}
                    onHide={this.handleEditPossibleValuesModalHide}
                  />

                  <div className={ fileAccepted ? "btnActions" : "text-right"}>
                    {fileAccepted
                    ? <button onClick={this.handleBackToFileReview} className="mr-2 whiteBtnSm">Back</button>
                    : null
                    }
                    <button
                      type="submit"
                      form="uploadStudentDataForm"
                      disabled={this.props.isLoading.uploadEvidenceData 
                        || !assessmentName.trim().length
                        || !selectedStudentIdColumn
                        || !selectedStudentFirstNameColumn
                        || !selectedStudentLastNameColumn
                        || !this.isRequiedBasicInfoFilled()}
                      className="blueBtnSm mt-3"
                    >
                      {`SAVE & IMPORT`}{" "}
                      {this.props.isLoading.uploadEvidenceData && (
                        <Spinner animation="border" size="sm" />
                      )}
                    </button>
                  </div>
                </>
              )}
            </Modal.Body>
          </Modal>
        }
        <SearchForYourAssessmentModal/>

      </>

    );
  }
}

const mapStateToProps = ({
  onboarding,
  groups,
  auth
}: ApplicationState): PropsFromState => {
  const { loadableFile } = onboarding;
  return {
    originalFileName: loadableFile ? loadableFile.originalFileName! : "",
    rawData: loadableFile ? loadableFile.rawData : [],
    currentDataPeriod: onboarding.currentDataPeriod,
    currentRole: auth.userInfo?.profile.current_role!,
    currentAssignmentRole: auth.userInfo?.profile.current_assignment?.role!,
    myId: auth.userInfo?.id!,
    columnsNames: loadableFile ? loadableFile.columnsNames : [],
    uploadCSVArray: loadableFile ? loadableFile.uploadCSVArray : [],
    showModal: onboarding.modalsState.uploadStudentDataModal,
    enterDataManuallyType: onboarding.modalsState.enterDataManuallyType,
    assessments: onboarding.assessments,
    evidencePeriodData: onboarding.evidencePeriodData,
    selectedAssessment: groups.selectedAssessment,
    teachers: onboarding.teachersRoster.map((teacher) => teacher.user),
    uploadedAssessment: onboarding.uploadedAssessment,
    dataPeriods: onboarding.dataPeriods,
    areas: groups.skillFocusInfo,
    isLoading: {
      uploadAssessmentData: onboarding.isLoading.uploadAssessmentData,
      assignStudentsToTeacher: onboarding.isLoading.assignStudentsToTeacher,
      addStudents: onboarding.isLoading.addStudents,
      uploadEvidenceData: onboarding.isLoading.uploadEvidenceData,
      detectAssessment: onboarding.isLoading.detectAssessment,
    },
    errors: {
      uploadAssessmentData: onboarding.errors.uploadAssessmentData,
      assignStudentsToTeacher: onboarding.errors.assignStudentsToTeacher,
      addStudents: onboarding.errors.addStudents,
      uploadEvidenceData: onboarding.errors.uploadEvidenceData,
      detectAssessment: onboarding.errors.detectAssessment,
    },
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      getEvidenceInDataPeriod: getEvidenceInDataPeriod,
      uploadCsvFile: uploadCsvFile,
      uploadMultipleCsvFile: uploadMultipleCsvFile,
      clearStoredCsvFile: clearStoredCsvFile,
      assignStudentsToTeacher: assignStudentsToTeacher,
      addStudents: addStudents,
      getTeachers: getTeachers,
      updateRawDataOfCsvFile: updateCsvFileRawData,
      uploadEvidenceData: uploadEvidenceData,
      uploadAssessmentData: uploadAssessmentData,
      openSearchForYourAssessmentModal: openSearchForYourAssessmentModal,
      openUploadStudentDataModal: openUploadStudentDataModal,
      onHide: hideUploadStudentDataModal,
      hidePickDataSourceModal: hidePickDataSourceModal,
      getSkillFocuses: getSkillFocuses,
      resetPagination: resetPagination,
      resetFilterAction: resetFilterAction,
      resetSortAction: resetSortAction,
      showConfirmDialog: showConfirmDialog,
      openFileUploadErrorModal: openFileUploadErrorModal
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadStudentDataModal);
